import api from "@/api";
const LIMIT = 10;

// let end = false;
let page = 1;

const state = () => ({
  empty: false,
  end: false,
  products: [],
  text: "",
});

const actions = {
  async fetch({ commit, dispatch, state }) {
    if (state.end) {
      return;
    }
    const data = await api({
      params: { limit: LIMIT, page, search: state.text },
      url: "/123/products",
    });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("UPDATE", data.info);
  },
  async fetchAndConcat({ commit, dispatch, state }) {
    if (state.end) {
      return;
    }
    const data = await api({
      params: { limit: LIMIT, page, search: state.text },
      url: "/123/products",
    });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("CONCAT", data.info);
  },
};

const mutations = {
  CLEAR_PRODUCTS(state) {
    state.empty = false;
    state.products = [];
  },
  CONCAT(state, products) {
    if (!state.products.length && !products.length && state.end !== true) {
      state.empty = true;
    }
    if (products.length <= LIMIT - 1) {
      state.end = true;
    }
    state.products = state.products.concat(products);
  },
  RESET(state) {
    state.empty = false;
    state.text = "";
    state.products = [];
  },
  UPDATE(state, products) {
    if (!state.products.length && !products.length && state.end !== true) {
      state.empty = true;
    }
    if (products.length <= LIMIT - 1) {
      state.end = true;
    }
    state.products = products;
  },
  UPDATE_PAGE() {
    page = ++page;
  },
  UPDATE_TEXT(state, text) {
    state.end = false;
    page = 1;
    state.text = text;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
